// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XVhBL","right":"styles_right__1tYgV"};